import React from 'react';
import './LoginField.css';

const LoginField = ({ label, type, value, onChange }) => {
    return (
        <div className="login-field">
            <div className="input-wrapper">
                <img src={process.env.PUBLIC_URL + '/branch.png'} alt="decorative branch" className="input-branch" />
                <label htmlFor={type} className="input-label">{label}</label>
                <input
                    type={type}
                    id={type}
                    value={value}
                    onChange={onChange}
                    required
                    placeholder={`${type}...`}
                />
            </div>
        </div>
    );
};

export default LoginField;
